import { StateCreator } from "zustand"
import { MAP_STYLES } from "@/constants/map-styles"
import { FlightRestrictionZoneResponse } from "@/api/v1/flight-restriction-zone-api";


type MapProjection = 'globe' | 'mercator';
export interface UserSlice {
    mapBounds: [number, number] // [lng, lat]
    mapZoom: number
    mapStyle: string
    mapStyleUrl: string
    mapProjection: MapProjection
    setMapProjection: (projection: MapProjection) => void
    setMapBounds: (bounds: [number, number]) => void
    setMapZoom: (zoom: number) => void
    setMapStyleUrl: (style: string) => void
    setMapStyle: (style: string) => void
    shouldShowAircraft: boolean
    setShouldShowAircraft: (shouldShow: boolean) => void
    shouldShowFlightRestrictions: boolean
    setShouldShowFlightRestrictions: (shouldShow: boolean) => void
    // Flight restriction zone drawer state
    selectedZone: FlightRestrictionZoneResponse | null
    setSelectedZone: (zone: FlightRestrictionZoneResponse | null) => void
    zoneDrawerOpen: boolean
    setZoneDrawerOpen: (open: boolean) => void
    // Zone filtering state
    zoneTypeFilter: string[]
    setZoneTypeFilter: (types: string[]) => void
    // Altitude range filtering state (for drone operating altitude)
    minAltitude: number | null
    maxAltitude: number | null
    setMinAltitude: (value: number | null) => void
    setMaxAltitude: (value: number | null) => void
}

export const createUserSlice: StateCreator<UserSlice> = (set) => ({
    mapBounds: [-0.9, 53.5],
    mapZoom: 5,
    mapStyle: MAP_STYLES[0].url,
    mapStyleUrl: MAP_STYLES[0].url,
    mapProjection: 'mercator',
    setMapProjection: (projection: MapProjection) => set({ mapProjection: projection }),
    setMapBounds: (bounds: [number, number]) => set({ mapBounds: bounds }),
    setMapZoom: (zoom: number) => set({ mapZoom: zoom }),
    setMapStyleUrl: (style: string) => set({ mapStyleUrl: style }),
    setMapStyle: (style: string) => set({ mapStyle: style }),
    shouldShowAircraft: true,
    setShouldShowAircraft: (shouldShow: boolean) => set({ shouldShowAircraft: shouldShow }),
    shouldShowFlightRestrictions: true,
    setShouldShowFlightRestrictions: (shouldShow: boolean) => set({ shouldShowFlightRestrictions: shouldShow }),
    // Flight restriction zone drawer state
    selectedZone: null,
    setSelectedZone: (zone: FlightRestrictionZoneResponse | null) => set({ selectedZone: zone }),
    zoneDrawerOpen: false,
    setZoneDrawerOpen: (open: boolean) => set({ zoneDrawerOpen: open }),
    // Zone filtering state
    zoneTypeFilter: ["Prohibited", "Restricted", "Danger"],
    setZoneTypeFilter: (types: string[]) => set({ zoneTypeFilter: types }),
    // Altitude range filtering state
    minAltitude: null,
    maxAltitude: null,
    setMinAltitude: (value: number | null) => set({ minAltitude: value }),
    setMaxAltitude: (value: number | null) => set({ maxAltitude: value })
});

